module.exports = __webpack_public_path__ + "static/img/數學師資介紹.188864c7.png";